// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Gear = function Gear(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M15.12 6.381h-1.7a5.687 5.687 0 00-1.308-2.265l.851-1.474a7.293 7.293 0 00-2.8-1.618L9.306 2.5a5.65 5.65 0 00-2.617 0l-.851-1.475a7.293 7.293 0 00-2.8 1.62l.85 1.473a5.64 5.64 0 00-1.304 2.263H.88a7.352 7.352 0 000 3.234h1.7a5.689 5.689 0 001.31 2.265l-.852 1.475a7.293 7.293 0 002.8 1.62l.854-1.475a5.65 5.65 0 002.613 0l.853 1.478a7.293 7.293 0 002.8-1.619l-.852-1.476a5.64 5.64 0 001.308-2.266h1.707a7.352 7.352 0 000-3.234zM8 11.188A3.188 3.188 0 1111.188 8 3.188 3.188 0 018 11.188z"
    }))
  );
};

export default Gear;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Gear.js
// module id = 1015
// module chunks = 0